export default ".unloading {\n  display: grid;\n  justify-content: center;\n}\n\n.copy-track {\n  align-self: center;\n  padding: 12px;\n}";